export const mtype = ['互动游戏', '计算相关互动', '专注力游戏', '产品化互动']



// WEBPACK FOOTER //
// ./src/components/index/type.js